import {Injectable, Inject, PLATFORM_ID} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';

import {isPlatformBrowser} from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {}

  scrollToTopOnNavigationEnd() {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((event: NavigationEnd) => {
        window.scroll(0, 0);
      });
    }
  }

  scrollToContentOnNavigationEnd() {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((event: NavigationEnd) => {
        const element = document.querySelector('app-root');
        element ? element.scrollIntoView() : undefined;
      });
    }
  }

  scrollToId(id: string) {
    if (isPlatformBrowser(this.platformId)) {
      const element = document.querySelector('#' + id);
      if (element) {
        element.scrollIntoView();
      }
    }
  }
}

